<div class="flex flex-flat max-width" *ngIf="!hideSearch">
  <mat-form-field appearance="outline" class="no-hint max-width" [ngClass]="{'with-suffix': suffixButton, 'bottom-spacer': !hideMap}" *ngIf="!readOnly">
    <mat-label>{{ 'general.api_search_location' | translate }}</mat-label>
    <input matInput type="text" (keydown.enter)="$event.preventDefault()" #search>
  </mat-form-field>
  <button mat-button type="button" *ngIf="suffixButton"
          class="input-button suffix-button" [ngClass]="{'icon-button': suffixButton.icon && (utilService.isMobile || !suffixButton.label)}"
          (click)="suffixButtonClick.emit()">
    <mat-icon class="svg-icon" *ngIf="suffixButton.icon" [svgIcon]="suffixButton.icon"></mat-icon>
    <ng-container *ngIf="suffixButton.label && !utilService.isMobile">{{ suffixButton.label | translate }}</ng-container>
  </button>
</div>
<ng-container *ngIf="apiLoaded | async">
  <div [className]="cssClass" *ngIf="!mapLoading" [ngClass]="{'display-none': hideMap}">
    <google-map [zoom]="mapZoom" [center]="mapCenter" [options]="mapOptions"
                (mapClick)="!readOnly && click($event)" [width]="'100%'" [height]="300">
      <map-marker
        #marker="mapMarker"
        [visible]="isMarkerVisible"
        [position]="mapCenter"
        [options]="markerOptions"
        (mapClick)="!readOnly && openInfoWindow(marker)"
        (mapDragend)="!readOnly && onMapDragEnd($event)">
      </map-marker>
      <map-info-window>{{ markerInfoContent }}</map-info-window>
    </google-map>
  </div>
</ng-container>
